<template>
  <div class="payments-editor-act">
    <divider orientation="left">Основные сведения</divider>
    <row :gutter="16">
      <i-col span="24">
        <div class="ms-help label">
          Тип платежа
        </div>
        <i-select
          @on-change="changeType"
          size="default"
          v-model="payment.type_id"
          :disabled="!!payment.id || !getContractModulePerms('contract_payments', 'update')"
        >
          <i-option v-for="type in types" :value="type.id" :key="type.id">
            {{ type.name }}
          </i-option>
        </i-select>
      </i-col>
    </row>
    <row v-if="payment.type_id !== 2" style="margin-top: 8px;" :gutter="16">
      <i-col span="24">
        <div class="ms-help label">
          Акт
        </div>
        <i-select
          size="default"
          v-model="payment.act_id"
          placeholder="Выберите акт"
          :disabled="!getContractModulePerms('contract_payments', 'update')"
        >
          <i-option
            v-for="act in acts"
            :value="act.id"
            :key="act.id"
            :label="getLabel(act)"
          >
            <div class="payments-editor-act__option">
              <span class="payments-editor-act__option-text ms-text ms-ellipsis"> Акт №{{ act.number }} </span>
              <span class="payments-editor-act__option-debt ms-help">
                (оплачено {{ getFormattedCosts(act.payments, true, true) }} /
                {{ getFormattedCosts(act.costs, true, true) }} )
              </span>
            </div>
          </i-option>
        </i-select>
      </i-col>
    </row>
    <payments-editor-roadmap
      v-show="payment.type_id === 2 || payment.act_id"
      :acts="acts"
      :roadmap="roadmap"
      :payment="payment"
      :payment-modal="paymentModal"
      :current-max-value="currentMaxValue"
    />
    <row style="margin-top: 8px;" :gutter="16" v-if="payment.type_id === 3">
      <i-col span="24">
        <div class="ms-help label">
          Описание платежа
        </div>
        <i-input
          v-model="payment.description"
          type="textarea"
          placeholder="Например, платеж за проживание"
          :disabled="!getContractModulePerms('contract_payments', 'update')"
        />
      </i-col>
    </row>
  </div>
</template>

<script>
import PaymentsEditorRoadmap from './payments-editor-roadmap'
import { parseDate, getFormattedCosts } from '@/utils'
import { paymentTypes as types } from '@/config/payments'

export default {
  props: ['payment', 'roadmap', 'acts', 'payment-modal', 'current-max-value'],
  components: {
    PaymentsEditorRoadmap
  },
  data () {
    return {
      types
    }
  },
  methods: {
    changeType (value) {
      if (value === 2) {
        this.payment.description = null
        this.payment.act_id = null
      }

      if (value === 1) {
        this.payment.description = null
        this.payment.roadmap_payments = []
        this.payment.value = 0
      }
    },
    getLabel ({ number, payments, costs }) {
      return `Акт №${number} (оплачено ${payments} / ${costs})`
    },
    parseDate,
    getFormattedCosts
  },
  computed: {
    currentAct () {
      if (!this.payment.act_id) return null

      return this.acts.find(act => act.id === this.payment.act_id)
    }
  }
}
</script>

<style lang="less">
.payments-editor-act {
  .ivu-checkbox {
    margin-right: 4px;
  }

  .ivu-checkbox-wrapper {
    margin-bottom: 8px;
  }

  &__info {
    font-size: 11px;
    margin-top: 4px;
  }

  &__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 32px;
    max-width: 720px;

    &-text {
      display: inline-block;
    }

    &-debt {
      margin-left: 8px;
    }
  }
}
</style>
